import Builder from '@form-engine/builder-application';
import { BsoThemeDefinition } from '../builder.plugin';

export function getBsoThemes() {
    return (Builder?.bsoThemes ?? {}) as Record<string, BsoThemeDefinition>;
}
